import { parse as D } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/parse.js";
import { isValid as O } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isValid.js";
import { formatDate as y } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { getMonth as m } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getMonth.js";
import { getTime as c } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getTime.js";
import { startOfMonth as C } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfMonth.js";
import { addDays as h } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/addDays.js";
import { getDay as Y } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getDay.js";
import { startOfYear as w } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfYear.js";
import { addMonths as N } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/addMonths.js";
import { addQuarters as j } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/addQuarters.js";
import { setYear as Q } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/setYear.js";
import { addYears as q } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/addYears.js";
import { getDate as M } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getDate.js";
import { getYear as p } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getYear.js";
import { isSameMonth as g } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameMonth.js";
import { isSameYear as k } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameYear.js";
import { getQuarter as x } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getQuarter.js";
import { isSameQuarter as b } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameQuarter.js";
import { isSameDay as F } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameDay.js";
import { isSameWeek as L } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameWeek.js";
const P = {
  date: F,
  month: g,
  year: k,
  quarter: b
};
function R(t) {
  return (e, r) => {
    const n = (t + 1) % 7;
    return L(e, r, {
      weekStartsOn: n
    });
  };
}
function i(t, e, r, n = 0) {
  return (r === "week" ? R(n) : P[r])(t, e);
}
function S(t, e, r, n, a, f) {
  return a === "date" ? W(t, e, r, n) : z(t, e, r, n, f);
}
function W(t, e, r, n) {
  let a = !1, f = !1, o = !1;
  Array.isArray(r) && (r[0] < t && t < r[1] && (a = !0), i(r[0], t, "date") && (f = !0), i(r[1], t, "date") && (o = !0));
  const u = r !== null && (Array.isArray(r) ? i(r[0], t, "date") || i(r[1], t, "date") : i(r, t, "date"));
  return {
    type: "date",
    dateObject: {
      date: M(t),
      month: m(t),
      year: p(t)
    },
    inCurrentMonth: g(t, e),
    isCurrentDate: i(n, t, "date"),
    inSpan: a,
    inSelectedWeek: !1,
    startOfSpan: f,
    endOfSpan: o,
    selected: u,
    ts: c(t)
  };
}
function dt(t, e, r) {
  const n = new Date(2e3, t, 1).getTime();
  return y(n, e, {
    locale: r
  });
}
function st(t, e, r) {
  const n = new Date(t, 1, 1).getTime();
  return y(n, e, {
    locale: r
  });
}
function mt(t, e, r) {
  const n = new Date(2e3, t * 3 - 2, 1).getTime();
  return y(n, e, {
    locale: r
  });
}
function z(t, e, r, n, a) {
  let f = !1, o = !1, u = !1;
  Array.isArray(r) && (r[0] < t && t < r[1] && (f = !0), i(r[0], t, "week", a) && (o = !0), i(r[1], t, "week", a) && (u = !0));
  const d = r !== null && (Array.isArray(r) ? i(r[0], t, "week", a) || i(r[1], t, "week", a) : i(r, t, "week", a));
  return {
    type: "date",
    dateObject: {
      date: M(t),
      month: m(t),
      year: p(t)
    },
    inCurrentMonth: g(t, e),
    isCurrentDate: i(n, t, "date"),
    inSpan: f,
    startOfSpan: o,
    endOfSpan: u,
    selected: !1,
    inSelectedWeek: d,
    ts: c(t)
  };
}
function B(t, e, r, {
  monthFormat: n
}) {
  return {
    type: "month",
    monthFormat: n,
    dateObject: {
      month: m(t),
      year: p(t)
    },
    isCurrent: g(r, t),
    selected: e !== null && i(e, t, "month"),
    ts: c(t)
  };
}
function E(t, e, r, {
  yearFormat: n
}) {
  return {
    type: "year",
    yearFormat: n,
    dateObject: {
      year: p(t)
    },
    isCurrent: k(r, t),
    selected: e !== null && i(e, t, "year"),
    ts: c(t)
  };
}
function G(t, e, r, {
  quarterFormat: n
}) {
  return {
    type: "quarter",
    quarterFormat: n,
    dateObject: {
      quarter: x(t),
      year: p(t)
    },
    isCurrent: b(r, t),
    selected: e !== null && i(e, t, "quarter"),
    ts: c(t)
  };
}
function pt(t, e, r, n, a = !1, f = !1) {
  const o = f ? "week" : "date", u = m(t);
  let d = c(C(t)), l = c(h(d, -1));
  const s = [];
  let A = !a;
  for (; Y(l) !== n || A; )
    s.unshift(S(l, t, e, r, o, n)), l = c(h(l, -1)), A = !1;
  for (; m(d) === u; )
    s.push(S(d, t, e, r, o, n)), d = c(h(d, 1));
  const I = a ? s.length <= 28 ? 28 : s.length <= 35 ? 35 : 42 : 42;
  for (; s.length < I; )
    s.push(S(d, t, e, r, o, n)), d = c(h(d, 1));
  return s;
}
function lt(t, e, r, n) {
  const a = [], f = w(t);
  for (let o = 0; o < 12; o++)
    a.push(B(c(N(f, o)), e, r, n));
  return a;
}
function ht(t, e, r, n) {
  const a = [], f = w(t);
  for (let o = 0; o < 4; o++)
    a.push(G(c(j(f, o)), e, r, n));
  return a;
}
function yt(t, e, r, n) {
  const a = n.value, f = [], o = w(Q(/* @__PURE__ */ new Date(), a[0]));
  for (let u = 0; u < a[1] - a[0]; u++)
    f.push(E(c(q(o, u)), t, e, r));
  return f;
}
function gt(t, e, r, n) {
  const a = D(t, e, r, n);
  return O(a) ? y(a, e, n) === t ? a : new Date(Number.NaN) : a;
}
function St(t) {
  if (t === void 0)
    return;
  if (typeof t == "number")
    return t;
  const [e, r, n] = t.split(":");
  return {
    hours: Number(e),
    minutes: Number(r),
    seconds: Number(n)
  };
}
function wt(t, e) {
  return Array.isArray(t) ? t[e === "start" ? 0 : 1] : null;
}
export {
  pt as dateArray,
  St as getDefaultTime,
  dt as getMonthString,
  mt as getQuarterString,
  st as getYearString,
  lt as monthArray,
  wt as pluckValueFromRange,
  ht as quarterArray,
  gt as strictParse,
  yt as yearArray
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/utils.js
// module id = 216
// module chunks = 67